import CitySEOHead from "@/components/feature/CitySEOHead";
import PlymouthMNHeroSection from "./components/HeroSection";
import PlymouthMNStickyNav from "./components/StickyNav";
import PlymouthMNProcessingTimeSection from "./components/ProcessingTimeSection";
import PlymouthMNServicesSection from "./components/ServicesSection";
import PlymouthMNLocalAreaSection from "./components/LocalAreaSection";
import PlymouthMNTravelTimingSection from "./components/TravelTimingSection";
import PlymouthMNDestinationsSection from "./components/DestinationsSection";
import PlymouthMNTestimonialsSection from "./components/TestimonialsSection";
import PlymouthMNAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PlymouthMNComparisonSection from "./components/ComparisonSection";
import PlymouthMNMistakesSection from "./components/MistakesSection";
import PlymouthMNHowItWorksSection from "./components/HowItWorksSection";
import PlymouthMNFAQSection from "./components/FAQSection";
import PlymouthMNHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PlymouthMNFinalCTA from "./components/FinalCTA";
import { faqs } from "./components/FAQSection";

export default function PlymouthMNPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Plymouth"
        state="Minnesota"
        stateAbbr="MN"
        route="/cities/plymouth-mn"
        title="Emergency Passport Plymouth, MN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Plymouth, MN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Medtronic professionals, Wayzata school district families, medical staff, and all of western Hennepin County."
        keywords="expedited passport Plymouth MN, emergency passport Plymouth, passport renewal Hennepin County"
        geoPlacename="Plymouth, Minnesota"
        geoPosition="45.0105;-93.4555"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
      />
      <PlymouthMNHeroSection />
      <PlymouthMNStickyNav />
      <PlymouthMNProcessingTimeSection />
      <PlymouthMNLocalAreaSection />
      <PlymouthMNServicesSection />
      <PlymouthMNTravelTimingSection />
      <PlymouthMNDestinationsSection />
      <PlymouthMNTestimonialsSection />
      <PlymouthMNAcceptanceFacilitiesSection />
      <PlymouthMNComparisonSection />
      <PlymouthMNMistakesSection />
      <PlymouthMNHowItWorksSection />
      <PlymouthMNFAQSection />
      <PlymouthMNHelpfulResourcesSection />
      <PlymouthMNFinalCTA />
    </div>
  );
}